
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import ChildElementConfiguration from '../configuration/ChildElementConfiguration';
import ElementConfiguration from '../configuration/ElementConfiguration';
import allComponents, { fixComponents, getComponentName } from './components';

@Component({
  name: 'Container',
  components: allComponents,
})
export default class Container extends ElementBase {
  getComponentName = getComponentName;

  private get childConfiguration(): ChildElementConfiguration {
    return this.configuration as ChildElementConfiguration;
  }

  get child(): ElementConfiguration | undefined {
    return this.childConfiguration.child;
  }

  beforeCreate(): void {
    fixComponents(this);
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);
    (this.$refs.element as ElementBase)?.onInformationPush(elementPath, json);
  }
}
